module.exports = __webpack_public_path__ + "media/customizations/christensoncommunities/back-82b5ccdc0889c89f98dec8f67012647b.jpg";